import EditArticleSheet from '../../components/EditArticleSheet'
import faqApi from '../../faq.api'
import faqEvents from '../../events/faq.events'
import { useNavigate } from 'react-router'
import { useSearchParams } from 'react-router-dom'
import FaqStateProvider from '../../components/FaqStateProvider'
import useHttpLoader from '../../../../../shared/hooks/useHttpLoader'
import AdminNavigationLayout from '../../../../../shared/Layouts/TopNavigationLayout/AdminNavifationLayout'
import TopNavigationLayoutPageContent from '../../../../../shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'
import Button from '../../../../../shared/Buttons/Button/Button'
import useFaqFormStateAndOptions from '../../hooks/useFaqFormState'

const CreateArticle = () => {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const { wait, loading } = useHttpLoader()

  const {
    state: [state, handleChange],
    checkpointsOptions,
    projectStagesOptions,
    projectTypesOptions,
  } = useFaqFormStateAndOptions({
    defaultValues: {
      title: '',
      categoryId: params.get('parent_id') ? parseInt(params.get('parent_id')) : null,
      text: '',
      ordering: 0,
      active: false,
      searchTags: [],
      relatedCheckpoints: [],
      relatedProjectRoles: [],
    },
  })

  const handleSubmit = () => {
    wait(faqApi.createArticle({ ...state, searchTags: state.searchTags.map((c) => c.id) }), (resp) => {
      if (resp.status === 'success') {
        faqEvents.articleCreated(resp.body)
        navigate('/admin/knowledge-base')
      }
    })
  }

  return (
    <AdminNavigationLayout>
      <TopNavigationLayoutPageContent type='default'>
        <div className='flex-space-between panel-layout__content-header'>
          <div className='flex-lines' style={{ gap: '7px' }}>
            <h2 className='page--header inline-flex-gap' style={{ gap: '7px' }}>
              <span>Новая статья</span>
            </h2>
          </div>
        </div>
        <EditArticleSheet
          article={state}
          onChange={handleChange}
          checkpointsOptions={checkpointsOptions}
          projectStagesOptions={projectStagesOptions}
          projectTypesOptions={projectTypesOptions}
        >
          <div
            className='form-footer inline-flex-gap'
            style={{ justifyContent: 'flex-end', width: '100%', flexDirection: 'row' }}
          >
            <Button style={{ width: 'fit-content' }} theme='primary' onClick={handleSubmit} loading={loading}>
              Сохранить
            </Button>
          </div>
        </EditArticleSheet>
      </TopNavigationLayoutPageContent>
    </AdminNavigationLayout>
  )
}

export default () => (
  <FaqStateProvider>
    <CreateArticle />
  </FaqStateProvider>
)
